import { render } from "./operation-cover.vue?vue&type=template&id=0ba1eded&scoped=true&ts=true"
import script from "./operation-cover.vue?vue&type=script&lang=ts"
export * from "./operation-cover.vue?vue&type=script&lang=ts"

import "./operation-cover.vue?vue&type=style&index=0&id=0ba1eded&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba1eded"],['__file',"src/views/wiki/components/operation-cover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ba1eded"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ba1eded', __exports__)) {
    console.log('reload')
    api.reload('0ba1eded', __exports__)
  }
  
  module.hot.accept("./operation-cover.vue?vue&type=template&id=0ba1eded&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0ba1eded', render)
  })

}


export default __exports__